import React, { useState } from 'react';
import styles from '../tax/ReadMore.module.css'; // Same CSS file as ReadMoreTaxTable
import {useTranslation} from "react-i18next";
import {LeasePackageDataTable} from "./LeasePackageDataTable";
import {LeasePackageDto} from "../../model/vehicle/vehicle";

interface ReadMoreLeasePackageTableProps {
    leasePackage: LeasePackageDto;
    maxHeight: number; // Maximum height in pixels
}

export function ReadMoreLeasePackageTable(props: ReadMoreLeasePackageTableProps){
    const {t, i18n} = useTranslation();

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div>
            <div
                className={`${styles.readMoreContent} ${!isExpanded ? styles.collapsed : ''}`}
                style={{ maxHeight: isExpanded ? 'none' : `${props.maxHeight}px`, overflow: "auto" }}
            >
                <LeasePackageDataTable leasePackage={props.leasePackage}/>
            </div>
            <div onClick={toggleExpand} style={{fontWeight: "800", cursor: "pointer"}}>
                {isExpanded ? t('package.readLess') : t('package.readMore')}
            </div>
        </div>
    );
}